import useAppContext from 'flow/hooks/useAppContext';

import QuotaStatRow from './QuotaStatRow';

type Props = {
    minutes: number | null;
};

const QuotaUsageRow = ({ minutes }: Props) => {
    const { i18next } = useAppContext();

    return (
        <QuotaStatRow
            label="settings.transcriptions.usage_minutes"
            value={
                minutes !== null
                    ? `${minutes} ${i18next.t('duration.minutes')}`
                    : undefined
            }
            skeletonWidth="w-24"
        />
    );
};

export default QuotaUsageRow;
